import * as XLSX from "xlsx";

/** Column order matches the `ticket_bulk_import` API's expected sheet layout. */
export const TICKET_BULK_IMPORT_COLUMNS = [
  "subject",
  "description",
  "status",
  "category",
  "tickettype",
  "sla",
  "is_vip",
  "priority",
  "project",
  "work_type",
  "parent_task",
  "taskestimatedhours",
] as const;

type TicketBulkImportRow = Record<
  (typeof TICKET_BULK_IMPORT_COLUMNS)[number],
  string | number | boolean
>;

const SAMPLE_ROWS: TicketBulkImportRow[] = [
  {
    subject: "Not create SLA in backend",
    description: "SLA does not create in service desk when ticket is submitted.",
    status: "new",
    category: "hardware",
    tickettype: "issue",
    sla: "on Track",
    is_vip: false,
    priority: "P2-High",
    project: "NIB RMS",
    work_type: "New Feature",
    parent_task: "Frontend Development",
    taskestimatedhours: 2,
  },
  {
    subject: "Second sample ticket",
    description: "Optional description",
    status: "new",
    category: "software",
    tickettype: "issue",
    sla: "on Track",
    is_vip: false,
    priority: "P3-Medium",
    project: "NIB CAD",
    work_type: "Bug / Defect",
    parent_task: "Backend Development",
    taskestimatedhours: 2,
  },
];

/** Downloads the sample `.xlsx` template for the ticket bulk-import API. */
export function downloadTicketBulkImportSample(
  filename = "ticket_bulk_import_sample.xlsx"
): void {
  const worksheet = XLSX.utils.json_to_sheet(SAMPLE_ROWS, {
    header: [...TICKET_BULK_IMPORT_COLUMNS],
  });
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "ticket_import_dummy");
  XLSX.writeFile(workbook, filename);
}
